module.exports = __webpack_public_path__ + "img/backgroundwrapperImg.224ab82c.png";